module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// DashboardLayer Widget

(function (fox) {
	"use strict";
	var _ = {
		getTranslation: function(alias) {
			var translation = {
				'affConfirm': fox.i18n.getTranslation('affConfirm', 'Aff confirm', 'dialog'),
				'welcomeAffiliateProgram': fox.i18n.getTranslation('welcomeAffiliateProgram', 'Welcome to ModelCentro Affiliate Program!', 'dialog')
			};

			return translation[alias] || '';
		}
	};

	fox.registerWidget('DashboardLayer', {

		configure: function () {
			this.isGlobalAffiliate = false;

			this.registerOptions('', {
				useAffilateCheckApi: false,
				widgets: {
					checkDataApi: {
						widget: 'Api',
						method: 'Model_Statistic.CheckAffiliateOnUniqs'
					},
					chartDashboard: {
						widget: 'Affiliate_Dashboard',
						group: 'dashboardChart',
						active: false,
						autoRender: true,
						container: '.promotion-block',
						template: 'affiliate_dashboard'
					},
					checkAffiliateApi: {
						widget: 'Api',
						method: 'affiliate.check'
					},
					affiliateCreateApi: {
						widget: 'Api',
						method: 'affiliate.create'
					},
					affiliateConfirm: {
						widget: 'PopupWidget',
						title: _.getTranslation('affConfirm'),
						darkOverlay: false,
						autoOpen: false,
						preventHideOnShadowClick: true,
						dialog: {
							closeOnEscape: false
						},
						widgets: {
							confirmation: {
								widget: 'Widget',
								autoRender: true,
								template: 'popup_affiliateconfirmation'
							}
						},
						handleDom: {
							accessAffiliate: {
								targetWidget: '#confirmation',
								target: '#p-apply',
								event: 'click',
								callback: fox.bind(function(){
									this.rwom1('#affiliateCreateApi').send({}, this);
								}, this)
							},
							exitAffiliate: {
								targetWidget: '#confirmation',
								target: '#p-cancel',
								event: 'click',
								callback: fox.bind(function(){
									var api;
									api = this.getApi('site_authorizer_logout', {
										method: 'site.authorizer.logout',
										httpMethod: 'post'
									});
									this.handleEvent(api, 'success', function () {
										fox.site.member = false;
										window.location.assign('/affiliates');
									});
									api.send();
								}, this)
							}
						}
					},
					successRegistrationPopup: {
						widget: 'PopupWidget',
						title: _.getTranslation('welcomeAffiliateProgram'),
						darkOverlay: false,
						autoOpen: false,
						preventHideOnShadowClick: true,
						dialog: {
							closeOnEscape: false,
							width: '500px'
						},
						widgets: {
							confirmation: {
								widget: 'Widget',
								autoRender: true,
								template: 'popup_congratulation',
								'hooks.onStartRendering': function () {
									var data = fox.site.member.getCollection();
									var id = fox.getObjectKeys(fox.site.member.getCollection())[0];

									this.setTemplateOptions({
										email: fox.objectGet(data, [id, 'email'].join('.')),
										pass: fox.objectGet(data, [id, 'password'].join('.'))
									});
								}
							}
						},
						handleDom: {
							accessAffiliate: {
								targetWidget: '#confirmation',
								target: '#start-using',
								event: 'click',
								callback: function(){
									fox.cookie.remove('affiliate_registration_complete');
									this.hide();
								}
							}
						}
					},
					emptyDashboardScreen: {
						widget: 'Widget',
						group: 'dashboardChart',
						active: false,
						autoRender: true,
						container: '.promotion-block',
						template: 'affiliate_client_empty_dashboard_screen'
					}
				},
				handleWom: {
					handleAffiliateCreateApiSuccess: {
						widget: '#affiliateCreateApi',
						event: ['success'],
						callback: '_handleAffiliateCreateApi'
					},
					successRegistrationPopupClose : {
						widget: '#successRegistrationPopup',
						event: 'hide',
						callback: function () {
							//fox.cookie.remove('affiliate_registration_complete');
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {

			if (fox.getEnv('globalAffiliateArea') === true) {
				this.isGlobalAffiliate = true;
			}

			if (this.isGlobalAffiliate && fox.cookie.get('affiliate_registration_complete')) {
				this.rwom1('#successRegistrationPopup').show();
			}

			if (this.getOption('sendApiOnRun') === true) this.getHitData();
			
			if (this.getOption('useAffilateCheckApi')) {
				this.checkAffiliate();
			}
			
			this.handleEvent(this.rwom1('#checkAffiliateApi'), 'success', fox.bind(function (response) {
				var res = response.answer.response;

				if (!res.client) {
					var title = 'Welcome to '+res.name+' Affiliate Program!';
					this.rwom1('#affiliateConfirm').setTitle(title).show();
				}

				if (res.id === this._affiliateCSV) {
					this.setTemplateOptions({
						affiliateCSV: true
					});
				}
			}, this));
			this.callParent('running', arguments);
		},

		activate: function () {
			this.getHitData();
		
			this.callParent('activate', arguments);
		},
		
		checkAffiliate: function (){
			if (this.isGlobalAffiliate) return;

			var api =  this.rwom1('#checkAffiliateApi');
			api.send({}, false);
		},

		getHitData: function () {
			return this.rwom1('#checkDataApi')
				.psend()
				.then(this.checkDataApiSuccess.bind(this))
				.catch(function (e) {
					console.error(e);
				});
		},

		checkDataApiSuccess: function (res) {
			var w = fox.objectGet(res, 'params.answer.response') ?
				'chartDashboard' :
				'emptyDashboardScreen';
			this.switchEmbeddedWidget(w);
		},
		
		_handleAffiliateCreateApi: function(response){
			var res = response.answer;
			
			if (res.status) {
				this.rwom1('#affiliateConfirm').hide();
			}
		}

	}, 'Controller');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/sitepage/affiliate/program/dashboardLayer.js
// module id = 351
// module chunks = 2